module.exports = {"id":"54051","name":"Wayne Routledge","rating":"75","photo":"./data/images/photos/1/54051.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["MD","AD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WayneRoutledge0.json
// module id = 4321
// module chunks = 0